import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { addEmail } from '../../../store/actions/EmailSignup';

function mapStateToProps(state) {
  return {
    isAddEmailPending: state.emailSignup.isAddEmailPending,
    isAddEmailSuccess: state.emailSignup.isAddEmailSuccess,
    serverEmailError: state.emailSignup.addEmailError,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addEmail: (email) => {
      dispatch(addEmail(email));
    }
  };
}

class EmailSignupForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      emailError: false,
      emailErrorMessage: null,
      hasAcceptedTerms: false,
    };
    this.submitEmail = this.submitEmail.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.handleCheckAcceptTerms = this.handleCheckAcceptTerms.bind(this);
  } 

  submitEmail(e) {
    e.preventDefault();
    let { email } = this.state;

    // Validate Forms
    if (!this.validateEmail(email)) { return }

    this.props.addEmail(email);
    this.setState({
      email: '',
    });
  }

  validateEmail(email) {
    if (!email) {
      this.setState({
        emailError: true,
        emailErrorMessage: 'Please enter an email'
      })
      return false; 
    }
    this.setState({
      emailError: false,
      emailErrorMessage: null
    })
    return true;
  }

  handleCheckAcceptTerms() {
    this.setState({hasAcceptedTerms: !this.state.hasAcceptedTerms});
  }



  render() {
    const { email, 
            emailError,
            emailErrorMessage,
            hasAcceptedTerms } = this.state;

    const { isAddEmailPending,
            isAddEmailSuccess,
            serverEmailError } = this.props;

    return (
      <div className="EmailSignupForm">
        <form name="emailSignupForm" onSubmit={this.submitEmail}>
          <div className="formRow formRow--75-25">
            <div className="formRow__item">
              <label for="email_signup">Your Email</label>
              <input 
                type="email" 
                name="email" 
                id="email_signup"
                placeholder="Email address" 
                value={email} 
                onChange={e => this.setState({email: e.target.value})} 
              />
            </div>
            <div className="formRow__item EmailSignup__button--desktop">
              <input className="btn btn--primary btn--100" type="submit" value="Sign up" disabled={!hasAcceptedTerms} />
            </div>
          </div>
          <p>
            <div className="checkbox__row">
              <div className="checkbox__item">
                <input
                  type="checkbox" 
                  id="checkbox_terms" 
                  alt="By signing up I agree to the Terms and Conditions and Privacy Policy"
                  onChange={this.handleCheckAcceptTerms}
                  defaultChecked={this.state.hasAcceptedTerms}
                />
                
                  <label htmlFor="checkbox_terms" className="legal-text">
                    By signing up I agree to the <Link to="terms">Terms & Conditions</Link> and <Link to="privacy">Privacy Policy</Link> and consent to recieving email communcations.
                  </label>
              </div>
            </div>
          </p>

          <div className="formRow__item EmailSignup__button--mobile">
            <input className="btn btn--primary btn--100" type="submit" value="Sign up" disabled={!hasAcceptedTerms} />
          </div>
          <div className="alert__container">
            <div className="alert--error center">
              { emailError && <div>{emailErrorMessage}</div> }
              { serverEmailError && <div>{loginError.message}</div> }
            </div>
            <div className="center">
              { isAddEmailPending && <div>Please wait...</div>}
            </div>
            <div className="alert--success center">
              { isAddEmailSuccess && <div>Your email has been submitted successfully. Use the promo code <b>THEMOOSEISLOOSE</b> for 10% off your order. We'll also send you a welcome email with this promo code.</div>}
            </div>
          </div>
        </form>

      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailSignupForm);


// WEBPACK FOOTER //
// ./src/components/Forms/EmailSignupForm/EmailSignupForm.js